import { adventureScenes } from '../content/scenes';
import type { ConditionEvaluator } from '../domain/rules/ConditionEvaluator';
import type { GameStateStore } from '../domain/state/GameStateStore';
import type { AdventureSceneDefinition } from '../domain/types';
import type { EventBus } from './events/EventBus';

export interface GameRuntime {
  events: EventBus;
  store: GameStateStore;
  evaluator: ConditionEvaluator;
  debugHotspots: boolean;
  getScene(sceneId: string): AdventureSceneDefinition;
}

let currentRuntime: GameRuntime | null = null;

export function installGameRuntime(runtime: GameRuntime): void {
  currentRuntime = runtime;
}

export function getGameRuntime(): GameRuntime {
  if (!currentRuntime) throw new Error('Spilruntime er ikke initialiseret.');
  return currentRuntime;
}

export function createGameRuntime(
  events: EventBus,
  store: GameStateStore,
  evaluator: ConditionEvaluator,
): GameRuntime {
  return {
    events,
    store,
    evaluator,
    debugHotspots: new URLSearchParams(window.location.search).get('debug') === 'hotspots',
    getScene(sceneId) {
      const scene = adventureScenes[sceneId];
      if (!scene) throw new Error(`Ukendt scene: ${sceneId}`);
      return scene;
    },
  };
}
